<div class="forecast-wrapper">
    <div class="content-align-self-center">
        <img class="icon" *ngIf="foreCastIconCode"
            [src]="'assets/images/WeatherIcons/' + getWeatherForecastIcon()" 
            [alt]="forecast">
    </div>
    <div class="desc-wrapper">
        <span class="text1 wrap-text">{{forecast ?? ""}}</span>
    </div>
    <div class="content-align-self-center">
        <span class="text2">{{airtemp ? airtemp + '°C' : '&nbsp;'}}</span>
    </div>
    <div class="content-align-self-center">
        <span class="text3">{{uvAlert ? "UV: " + uvAlert : '&nbsp;'}}</span>
    </div>
    <div class="content-align-self-center" *ngIf="uvOrOtherValue" >
        <span class="text3">{{uvOrOtherValue ? uvOrOtherLabel + uvOrOtherValue  : '&nbsp;'}}</span>
    </div>
</div>